<template>
  <v-container fluid style="max-width: 600px">
    <v-row justify="center" class="headline">
      <v-col cols="2">
        <v-card
          :color="colorFor(guessed - 1)"
          outlined
        >
          <v-responsive
            aspect-ratio="1"
          />
        </v-card>
      </v-col>
      <v-col
        class="d-flex justify-center align-center"
        cols="8"
      >
        <span
          v-if="time"
        >
          {{time | round}}
        </span>
      </v-col>
      <v-col cols="2">
        <v-card
          :color="colorFor(guessed)"
          outlined
        >
          <v-responsive
            aspect-ratio="1"
          />
        </v-card>
      </v-col>
    </v-row>
    <v-card outlined class="ma-4">
      <v-progress-linear
        :value="guessed/total*100"
        :color="colors[currentStage] || 'white'"
        height="8"
      />
      <v-row class="mx-0">
        <template
          v-for="(i, idx) in screen"
        >
          <v-col
            :key="i"
          >
            <v-card
              v-on="clickHandler(i)"
              :color="colorFor(i)"
              v-ripple
            >
              <v-responsive
                aspect-ratio="1"
                class="d-flex align-center justify-center text-center white--text headline"
              >
                <span>
                  <!-- {{i}} -->
                </span>
              </v-responsive>
            </v-card>
          </v-col>
          <v-responsive
            v-if="(idx + 1) % columns === 0"
            :key="`break-${idx}`"
            width="100%"
          />
        </template>
      </v-row>
    </v-card>
    <v-dialog
      :value="guessed === total"
      max-width="500px"
      persistent
    >
      <v-card
        class="mx-auto"
      >
        <v-card-title>
          Enhorabuena!
        </v-card-title>
        <v-card-subtitle>
          <v-row justify="center">
            <v-card
              v-for="color in colors"
              :color="color"
              :key="color"
              class="mx-3 my-4"
              width="20px"
            >
              <v-responsive
                aspect-ratio="1"
              />
            </v-card>
            <span
              v-if="failureRate > 0"
              class="my-auto red--text"
            >
              {{failureRate | round}} %
            </span>
          </v-row>
        </v-card-subtitle>
        <v-card-text class="display-1 text-center">
          {{time | round}}
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            @click="again"
          >
            Otra vez
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
const shuffle = (original, replace = false) => {
  const array = replace ? original : original.slice()

  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[array[i], array[j]] = [array[j], array[i]]
  }

  return array
}

export default {
  name: 'Colors',
  data () {
    return {
      colors: [
        'pink',
        'green',
        'purple',
        'yellow'
      ],
      failed: 0,
      gridsize: 9,
      columns: 3,
      shades: 9,
      guessed: 0,
      time: 0
    }
  },
  methods: {
    guess (idx) {
      if (idx === this.guessed) {
        this.guessed++
        if (this.guessed === this.total) {
          this.$emit('stop')
        }
      } else {
        this.time += 0.5
        this.failed += 1
      }
      this.$emit('start')
    },
    colorFor (idx) {
      if (idx === null) {
        return 'white'
      }

      const main = Math.floor(idx / this.shades)
      return this.range(this.colors[main])[idx % this.shades]
    },
    range (main) {
      const lighten = Array.from(Array(4), (_, idx) => 4 - idx)
      const darken = Array.from(Array(4), (_, idx) => idx + 1)
      const shades = [
        lighten.map(shade => `lighten-${shade}`),
        '',
        darken.map(shade => `darken-${shade}`)
      ].flat().map(shade => `${main} ${shade}`.trim())

      return shades
    },
    again () {
      location.reload()
    }
  },
  mounted () {
    this.$once('start', () => {
      const i = setInterval(() => {
        this.time += 0.05
      }, 50)

      this.$once('stop', () => {
        clearInterval(i)
      })
    })
  },
  computed: {
    clickHandler (vm) {
      const touch = 'ontouchstart' in document

      const events = new Map([
        [true, 'touchstart'],
        [false, 'mousedown']
      ])

      return (value) => ({
        [`${events.get(touch)}`] (e) {
          vm.guess(value)
        }
      })
    },
    failureRate () {
      return this.failed / this.guessed * 100
    },
    screen () {
      return (this.order[this.currentStage] || []).map((cell, idx) => {
        if (cell >= this.guessed) {
          return cell
        }

        return this.order?.[this.currentStage + 1]?.[idx]
      })
    },
    order () {
      const all = Array.from(Array(this.total), (_, idx) => idx)

      return Array.from(Array(this.totalStages), (_, stage) => {
        const stageTiles = all.slice(stage * this.gridsize, (stage + 1) * this.gridsize)
        const fill = Array.from(Array(this.gridsize - stageTiles.length), () => null)
        return shuffle(stageTiles.concat(fill))
      })
    },
    totalStages () {
      return Math.ceil(this.total / this.gridsize)
    },
    currentStage () {
      return Math.floor(this.guessed / this.gridsize)
    },
    total () {
      return this.colors.length * this.shades
    }
  }
}
</script>
